import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrPatchVacation, CreateVacation, Vacation } from '@thro-types/leihbar';

import { AxiosRequestConfig } from 'axios';

import {
  createVacation,
  deleteVacation,
  getVacationsForLenderGroupId,
  updateVacation
} from 'api/leihbar';

export const useVacationsQuery = (lenderGroupId: number, config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['vacations', lenderGroupId, config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      const vacations = getVacationsForLenderGroupId(lenderGroupId, config);
      return vacations;
    },
    initialData: { vacations: [], vacationCount: 0 }
  });

  return query;
};

export const useVacationsMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['vacations'];
  const creation = useMutation<Vacation, Error, CreateVacation>({
    mutationFn: async args => {
      return await createVacation(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<Vacation, Error, { id: number; data: CreateOrPatchVacation }>({
    mutationFn: async args => {
      return await updateVacation(args.id, args.data, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const deletion = useMutation<Vacation, Error, number>({
    mutationFn: async args => {
      return await deleteVacation(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { creation, update, deletion } as const;
};
